module.exports = __webpack_public_path__ + "img/ios_tips.6ecd80d7.png";